export const onlineLocationPlaceholder = "t06P1d";
export default {onlineLocationPlaceholder};